<template>
  <v-row no-gutters class="pa-2">
    <v-col cols="12" md="4" class="pa-2 mb-4 sticky-md" style="top: 12px">
      <v-tabs
        v-model="qrShow"
        color="primary"
        background-color="grey lighten-3 pa-1"
        class="rounded-pill mx-auto pa-1"
        height="48"
        style="width: fit-content"
      >
        <v-tab :ripple="true" :disabled="e6 <= 1"> {{ $t("view_qr") }} </v-tab>

        <v-tab :ripple="true"> {{ $t("preview") }} </v-tab>
        <v-tab :ripple="true" :disabled="e6 <= 1">تعرفه‌ها</v-tab>

      </v-tabs>
    </v-col>

    <v-col cols="8" v-show="$vuetify.breakpoint.mdAndUp" />

    <v-col
      cols="12"
      md="4"
      class="pa-2 sticky-md"
      style="top: 110px; height: fit-content"
    >
      <v-tabs-items
        v-model="qrShow"
        class="overflow-visible mb-4 mb-md-0"
        touchless
      >
        <v-tab-item>
          <qr-maker :svg="svgMade" :loading="loading" />
          <v-btn class="btn-download" @click="showDialog = true">
            <v-icon>mdi-progress-download</v-icon>
            {{ $t("download_qr") }}
          </v-btn>
        </v-tab-item>

        <v-tab-item>
          <component v-bind:is="MobileViwer" :data="cardTexts" />
        </v-tab-item>
        <v-tab-item v-if="!!info?.id && e6>1">
          <Tariffs :id_qr="info.id" :qrtype="'VisitCard'" />
        </v-tab-item>

      </v-tabs-items>
    </v-col>

    <v-col cols="12" md="8" class="pa-2 px-0">
      <template>
        <v-stepper class="px-0 mx-0" vertical flat v-model="e6">
          <v-stepper-step :complete="e6 > 1" class="px-0 px-md-4" step="1">
            <div class="row justify-center">
              <div class="col-md-12">
                <p>{{ $t("enter_visit_card_info") }}</p>
              </div>
              <div class="col-md-6 mt-0 pt-0">
                <v-text-field
                  v-model="cardTexts.visitName"
                  :label="$t('visit_card_name')"
                  dense
                  class="mt-0 pt-0"
                  outlined
                  append-icon="mdi-pen"
                  clearable
                  clear-icon="mdi-close-circle-outline"
                  :disabled="e6 > 1"
                />
              </div>
              <div class="col-md-6 mt-0 pt-0">
                <qr-address-field
                  v-model="dtUrl"
                  dense
                  persistent-hint
                  class="mt-0 pt-0"
                  :hint="$t('enter_qr_address')"
                  :disabled="e6 > 1"
                  outlined
                  append-icon="mdi-web"
                  id="qr-address"
                  :error-messages="errors['identifier']"
                :key="$t('qrAddressUpdate.hints.allowedChars')"

                />
              </div>
            </div>
          </v-stepper-step>

          <v-stepper-content step="1" class="pr-1 mx-0 mr-md-7 px-md-4">
            <list-expansion
              v-model="cardTexts"
              flat
              :components="specialInfo"
              :data="cardTexts"
            />
            <qr-generator />

            <div class="col-md-12">
              <next-btn @click="markQr(false)" style="background: #1b8d39" />
            </div>
          </v-stepper-content>

          <v-stepper-step class="px-0 px-md-4" :complete="e6 > 2" step="2">{{
            $t("qr_settings")
          }}</v-stepper-step>

          <v-stepper-content step="2" class="pr-1 mx-0 mr-md-7 px-md-4">
            <qr-management :qrId="shortId" ref="qrManage" />

            <div class="row mx-auto">
              <div class="col-md-6">
                <prev-btn @click="e6 = 1" />
              </div>

              <div class="col-md-6">
                <next-btn @click="setSettings" />
              </div>
            </div>
          </v-stepper-content>

          <v-stepper-step class="px-0 px-md-4" :complete="e6 > 3" step="3">{{
            $t("qr_design")
          }}</v-stepper-step>

          <v-stepper-content step="3" class="pr-1 mx-0 mr-md-7 px-md-4">
            <qr-customize v-model="qrDesign" />

            <div class="row mx-auto">
              <div class="col-md-6">
                <prev-btn
                  :text="$t('edit')"
                  style="background: orange"
                  @click="goto(`qr/${createdId}/edit`)"
                  v-if="finish"
                />

                <prev-btn @click="e6 = 2" v-else />
              </div>

              <div class="col-md-6">
                <v-btn
                  v-if="finish"
                  class="btn-download float-left"
                  @click="showDialog = true"
                >
                  <v-icon>mdi-progress-download</v-icon>
                  {{ $t("download_qr") }}
                </v-btn>

                <next-btn
                  v-else
                  @click="qrUpdate(true)"
                  :text="$t('register')"
                />
              </div>
            </div>
          </v-stepper-content>
        </v-stepper>
      </template>
    </v-col>

    <custom-popup
      v-model="showDialog"
      max-width="900"
      hide-overlay
      :cons="cons"
      transition="dialog-bottom-transition"
      hide-confirm
    >
      <template v-slot:helpinfo>
        <help-info
          :element-name="`${serviceName}-${componentName}-data-show-download-d`"
          :service-name="serviceName"
          :help-data="helpData"
          class="buttoninfo"
          :label="$t('download_qr')"
        />
      </template>
      <v-card class="px-5">
        <download-file
          :svg="svgMade"
          v-if="showDialog"
          :eye-style="eyeStyle"
          :qr-style="qrStyle"
          :visit-name="cardTexts.visitName"
          :dynam="true"
          :data="{ theme: '', data: cardTexts }"
          type="visitCard"
          destination_url="https://t.qrland.ir/"
        />
      </v-card>
    </custom-popup>
  </v-row>
</template>

<script>
import MobileViwer from "../qrland/components/mobileViwer";
import QrGenerator from "../qrland/components/qrGenerator";
import QrMaker from "../qrland/components/qrMaker";
import { Bus, debounce } from "@/main";
import QrCustomize from "../qrland/components/qrCustomize";
import DownloadFile from "../qrland/downloadFile.vue";
import QrManagement from "../qrland/components/qrManage/qrManagement";
import ListExpansion from "../../content/fragments/listExpansion";
import NextBtn from "../../content/fragments/nextBtn";
import PrevBtn from "../../content/fragments/prevBtn";
import QrAddressField from "../../content/fragments/qrAddressField";
import { mapGetters } from "vuex";
import CallToAction from "@/view/components/CallToAction";
import Tariffs from "../../components/Tariffs/Tariffs.vue";

export default {
  name: "cardVisit",
  components: {
    CallToAction,
    QrAddressField,
    PrevBtn,
    NextBtn,
    ListExpansion,
    QrManagement,
    DownloadFile,
    QrCustomize,
    QrMaker,
    QrGenerator,
    MobileViwer,
    Tariffs
  },
  data() {
    return {
      qrDesign: {},
      cons: { title: this.$t("download_qr") },
      e6: 1,
      errors: {},
      createdId: null,
      shortId: null,
      finish: true,
      loading: false,
      showDialog: false,
      customTheme: [{ name: "MobileViwer", value: "" }],
      specialInfo: [
        {
          name: "textCards",
          value: "",
          title: this.$t("user_info"),
          subtitle: "",
          icon: "account-outline",
        },
        {
          name: "Faq",
          value: "",
          title: "Faq",
          subtitle: "",
          icon: "account-outline",
        },
        {
          name: "Selector",
          value: "",
          title: "Selector",
          subtitle: "",
          icon: "account-outline",
        },
        {
          name: "videoGallery",
          value: "",
          title: "Video Gallery",
          subtitle: "",
          icon: "account-outline",
        },
        {
          name: "pdfSelector",
          value: "",
          title: "Pdf Gallery",
          subtitle: "",
          icon: "account-outline",
        },
        {
          name: "FeedBack",
          value: "",
          title: "Feed Back",
          subtitle: "",
          icon: "account-outline",
          model: "feedback",
        },
        {
          name: "Service",
          value: "",
          title: "Service",
          subtitle: "",
          icon: "account-outline",
        },
        {
          name: "Consultation",
          value: "",
          title: "Consultation",
          subtitle: "",
          icon: "alien",
        },
        {
          name: "Counter",
          value: "",
          title: "Counter",
          subtitle: "",
          icon: "alien",
        },
        {
          name: "Product",
          value: "",
          title: "Product",
          subtitle: "",
          icon: "alien",
        },
        {
          name: "WorkSheet",
          value: "",
          title: "WorkSheet",
          subtitle: "",
          icon: "alien",
        },
        {
          name: "Personnel",
          value: "",
          title: "Personnel",
          subtitle: "",
          icon: "alien",
        },
        {
          name: "Customer",
          value: "",
          title: "Customer",
          subtitle: "",
          icon: "alien",
        },
        {
          name: "CounterService",
          value: "",
          title: "Counter Service",
          subtitle: "",
          icon: "alien",
        },
        {
          name: "ServiceSection",
          value: "",
          title: "Service Section",
          subtitle: "",
          icon: "alien",
        },
      ],
      headColor: "linear-gradient(to right , #D81A1AFF, #2115A7FF)",
      bodyColors: "",
      eyeStyle: "",
      qrStyle: "",
      qrSize: "",
      dtUrl: null,
      cardTexts: {
        pallete: {},
        visitName: this.$t("visit_card"),
        isGradient: false,
        organizationName: this.$t("terminal_ads"),
        subOrgan: this.$t("manage_40_advertising_methods"),
        userName: this.$t("ms_khansari"),
        workField: this.$t("support"),
        phoneNumber: [{ number: "90007425" }],
        extraFields: [
          {
            icon: "",
            name: "",
            value: "",
          },
        ],
        companyNumber: "02191017077",
        email: "info@terminalads.com",
        fax: "02191016066",
        feedback: [
          { question: "", selected: "", description: false, forceDesc: false },
        ],
        location: "",
        city: "",
        photo: {},
        codePostal: "1541946815",
        province: "",
        country: "",
        website: "www.terminalads.com",
        socialMedia: {},
        aboutUs:
          '<div><h1 class="aux-modern-heading-primary"><font size="3">تنها سامانه جامع بررسی و مدیریت تبلیغات آنلاین</font></h1></div><div><div class="aux-modern-heading-description"><p style="text-align: justify">سامانه\n ترمینال تبلیغات مفتخر است تا از رهگذر ارتباط مداوم و تاثیرگذار با \nمشتریان و مخاطبان خود از نیازهای آنها آگاه گردیده و بهترین راهکارها را \nدر اختیارشان قرار دهد.&nbsp;</p><p style="text-align: right">سامانه ترمینال \nتبلیغات بزرگترین و مهمترین سرمایه خود را مشتریان و کاربران وفادار می \nداند و در درجه دوم تیم متخصص و کارآمد که با ایده های جدید و فناوری های \nنوین شرکت را یاری می کنند.</p></div></div>',
        center: [51.420296, 35.732379],
        coordinates: [51.420296, 35.732379],
        address: "",
        apiKey:
          "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIn0.eyJhdWQiOiIyMDI5NSIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIiwiaWF0IjoxNjcwNjg5MDc4LCJuYmYiOjE2NzA2ODkwNzgsImV4cCI6MTY3MzE5NDY3OCwic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.h-KYgigwSQbp9KYjIjWgBLQRpMy6ABa40dyF4pF99UmndnhDNs-fckFePIdRPkm7GlggWm9yKphj_TJ5b9TyA8m1_gNarjRiPzhAS5ZNGNUaSfnGHA1cUbc71DuUKgohAe2sOmXUkKin0q-ErzDdCczJjLVc218dRkCxLuJIrAY5yZ5yVgK79-Q6misDYP3yLpWaV5uDA3a1VzXppq4G9hm0GCGmsef_WryEx9z1fFuOzoVbuNj2yEKn3mBi2vAyKvV1HRMKMoXy_KLTk8xy-GsSQArOxKvw4Nk8Nvuks0WzSlLygNncQozltpm5Z4kueep-0TrI4xzx6uSjuk20vg",
      },
      qrShow: 1,
      svgMade: "",
      destinationUrl: "",
    };
  },

  methods: {
    updateTranslations() {
      this.cardTexts.visitName = this.$t("visit_card");
      this.cardTexts.organizationName = this.$t("terminal_ads");
      this.cardTexts.subOrgan = this.$t("manage_40_advertising_methods");
      this.cardTexts.userName = this.$t("ms_khansari");
      this.cardTexts.workField = this.$t("support");
      this.cardTexts.location = this.$t("tehran_address");
      this.cardTexts.aboutUs = this.$t("about_us_terminal_ads");
      this.cardTexts.socialMedia = {
        address: [
          {
            hint: this.$t("please_enter_your_address"),
            label: this.$t("address"),
            url: "www.qrland.ir",
            img: "/media/socialIcon/40icon/location.svg",
            svg: "svgLocation",
          },
          {
            hint: this.$t("please_enter_your_address"),
            label: this.$t("address"),
            url: "www.qr.terminalads.com",
            img: "/media/socialIcon/40icon/location.svg",
            svg: "svgLocation",
          },
        ],
        instagram: [
          {
            hint: this.$t("please_enter_instagram_address"),
            label: this.$t("instagram"),
            url: "https://instagram.com/terminalads",
            img: "/media/socialIcon/40icon/instagram.svg",
            svg: "svgInstagram",
          },
        ],
        whatsapp: [
          {
            hint: this.$t("please_enter_whatsapp_address"),
            label: this.$t("whatsapp"),
            url: "https://wa.me/982191017077",
            img: "/media/socialIcon/40icon/whatsapp.svg",
            svg: "svgWhatsapp",
          },
        ],
      };
    },
    markQr(final = false) {
      if (!this.dtUrl || this.dtUrl.length < 3) {
        this.$toast.error(this.$t("please_enter_qr_address_correctly"));
        return;
      }

      this.loading = true;
      let obj = {
        type: "VisitCard",
        format: "svg",
        color: ["#001554"],
        qrType: "dynamic",
        visitName: this.cardTexts.visitName,
        size: this.qrSize ? this.qrSize : 248,
        eye: this.eyeStyle ? this.eyeStyle : undefined,
        style: this.qrStyle ? this.qrStyle : undefined,
        margin: 0,
        destination_url: "https://qr2.in/",
        VisitCard: JSON.stringify({
          theme: "",
          data: this.cardTexts,
        }),
        qr: {
          section: "#link",
          link: "https://qr2.in/",
          backcolor: "#ffffff",
          frontcolor: "#000000",
          gradient_color: "#000000",
          marker_out_color: "#000000",
          marker_in_color: "#000000",
          marker_top_right_outline: "#000000",
          marker_top_right_center: "#000000",
          marker_bottom_left_outline: "#000000",
          marker_bottom_left_center: "#000000",
          framecolor: "#000000",
          optionlogo: "none",
          "logo-size": 100,
          marker: "default",
          marker_in: "default",
          outer_frame: "none",
          framelabel: "SCAN ME",
          label_font: "AbrilFatface.svg",
          "label-text-size": 100,
          size: "248",
          level: "M",
        },
      };
      if (this.dtUrl && this.dtUrl.length > 0) {
        obj.identifier = this.dtUrl;
      }

      this.$api
        .post("/v1/Qr", obj)
        .then(({ data }) => {
          this.finish = final;
          this.loading = false;
          this.preview(data.data.short_url.destination_url);
          this.createdId = data.data.id;
          this.shortId = data.data.short_url.id;
          this.destinationUrl = data.data.short_url.destination_url;
          this.svgMade = data.data.svg;
          this.qrShow = 0;
          this.$toast.success(this.$t("visit_card_created_successfully"));
          if (this.e6 === 1) {
            this.e6 = 2;
          }
        })
        .catch(({ response }) => {
          this.errors = response.data.errors;
          let el = document.getElementById("qr-address");
          el.scrollIntoView({ behavior: "smooth", block: "center" });
          this.loading = false;
          // this.$toast.error('خطای سرور!')
        })
        .finally(() => {
          this.loading = false;
        });
    },
    preview(link) {
      this.loading = true;
      this.$api
        .post("/v1/Qr/preview", {
          section: "#link",
          link: link,
          backcolor: !this.qrDesign.qrStyleColors?.backcolor
            ? "#ffffff"
            : this.qrDesign.qrStyleColors?.backcolor,
          gradient_color: !this.qrDesign.qrStyleColors?.gradient_color
            ? "#8900d5"
            : this.qrDesign.qrStyleColors?.gradient_color,
          frontcolor: !this.qrDesign.qrStyleColors?.frontColor
            ? "#000000"
            : this.qrDesign.qrStyleColors?.frontColor,
          gradient: this.qrDesign.qrStyleColors?.gradient ? "on" : undefined,
          pattern: this.qrDesign.qrStyleColors.pattern,
          marker_in: this.qrDesign.MarkerCenter.eyePattern,
          marker_in_color: this.qrDesign.MarkerCenter.main,
          markers_color: "on",
          marker: this.qrDesign.QrMarkOut.markOutPattern,
          different_markers_color:
            this.qrDesign.QrMarkOut.different_markers_color ||
            this.qrDesign.MarkerCenter.different_markers_color
              ? "on"
              : undefined,
          marker_out_color: this.qrDesign.QrMarkOut.main,
          marker_top_right_outline: this.qrDesign.QrMarkOut.topRight,
          marker_top_right_center: this.qrDesign.MarkerCenter.topRight,
          marker_bottom_left_outline: this.qrDesign.QrMarkOut.bottomLeft,
          marker_bottom_left_center: this.qrDesign.MarkerCenter.bottomLeft,
          custom_frame_color: this.qrDesign.QrFrame?.different_markers_color
            ? "on"
            : undefined,
          outer_frame: this.qrDesign.QrFrame.framePattern,
          framecolor: this.qrDesign.QrFrame.main,
          framelabel: this.qrDesign.QrFrame.text,
          optionlogo: this.qrDesign.LogoImg.logoImg,
          no_logo_bg: this.qrDesign.LogoImg.noBg ? "on" : undefined,
          "logo-size": this.qrDesign.LogoImg.logoSize,
          label_font: "AbrilFatface.svg",
          "label-text-size": "100",
          size: "248",
          level: "H",
        })
        .then((res) => {
          this.loading = false;
          this.svgMade = res.data.data;
        })
        .catch((err) => {
          this.loading = false;
          // this.$toast.error('خطای سرور!')
        })
        .finally(() => {
          this.loading = false;
        });
    },
    async setSettings() {
      const res = await this.$refs.qrManage.update();
      this.e6 = 3;
    },
    qrUpdate(final = false) {
      this.loading = true;

      const data = new URLSearchParams();
      data.append("type", "VisitCard");
      data.append("format", "svg");
      data.append("qrType", "dynamic");
      data.append("margin", "0");
      data.append("id", this.createdId);
      data.append("qr_id", this.info.id);
      data.append("svg", this.svgMade);
      data.append(
        "VisitCard",
        JSON.stringify({
          theme: "",
          data: this.cardTexts,
        })
      );
      data.append(
        "qr[backcolor]",
        !this.qrDesign.qrStyleColors?.backcolor
          ? "#ffffff"
          : this.qrDesign.qrStyleColors?.backcolor
      );
      data.append(
        "qr[gradient_color]",
        !this.qrDesign.qrStyleColors?.gradient_color
          ? "#000000"
          : this.qrDesign.qrStyleColors?.gradient_color
      );
      data.append(
        "qr[frontcolor]",
        !this.qrDesign.qrStyleColors?.frontColor
          ? "#000000"
          : this.qrDesign.qrStyleColors?.frontColor
      );
      data.append(
        "qr[gradient]",
        this.qrDesign.qrStyleColors?.gradient ? "on" : undefined
      );
      data.append("qr[pattern]", this.qrDesign.qrStyleColors.pattern);
      data.append("qr[marker_in]", this.qrDesign.MarkerCenter.eyePattern);
      data.append("qr[marker_in_color]", this.qrDesign.MarkerCenter.main);
      data.append("qr[markers_color]", "on");
      data.append("qr[marker]", this.qrDesign.QrMarkOut.markOutPattern);
      data.append(
        "qr[different_markers_color]",
        this.qrDesign.QrMarkOut.different_markers_color ||
          this.qrDesign.MarkerCenter.different_markers_color
          ? "on"
          : undefined
      );
      data.append("qr[marker_out_color]", this.qrDesign.QrMarkOut.main);
      data.append(
        "qr[marker_top_right_outline]",
        this.qrDesign.QrMarkOut.topRight
      );
      data.append(
        "qr[marker_top_right_center]",
        this.qrDesign.MarkerCenter.topRight
      );
      data.append(
        "qr[marker_bottom_left_outline]",
        this.qrDesign.QrMarkOut.bottomLeft
      );
      data.append(
        "qr[marker_bottom_left_center]",
        this.qrDesign.MarkerCenter.bottomLeft
      );
      data.append(
        "qr[custom_frame_color]",
        this.qrDesign.QrFrame?.different_markers_color ? "on" : undefined
      );
      data.append("qr[outer_frame]", this.qrDesign.QrFrame.framePattern);
      data.append("qr[framecolor]", this.qrDesign.QrFrame.main);
      data.append("qr[framelabel]", this.qrDesign.QrFrame.text);
      data.append("qr[optionlogo]", this.qrDesign.LogoImg.logoImg);
      data.append(
        "qr[no_logo_bg]",
        this.qrDesign.LogoImg.noBg ? "on" : undefined
      );
      data.append("qr[label_font]", "AbrilFatface.svg");
      data.append("qr[size]", "248");
      data.append("qr[level]", "H");
      data.append('qr["logo-size"]', this.qrDesign.LogoImg.logoSize);
      data.append('qr["label-text-size"]', "100");

      this.$api
        .put("/v1/Qr/update", data, {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        })
        .then((res) => {
          this.finish = final;
          this.$toast.success(this.$t("visit_card_edited_successfully"));
        })
        .catch((err) => {
          this.loading = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },

  mounted() {
    this.updateTranslations();
    this.cardTexts.visitName = this.$t("visit_card");
    this.cardTexts.organizationName = this.$t("terminal_ads");
    this.cardTexts.subOrgan = this.$t("manage_40_advertising_methods");
    this.cardTexts.userName = this.$t("ms_khansari");
    this.cardTexts.workField = this.$t("support");
    this.cardTexts.location = this.$t("tehran_address");
    this.cardTexts.aboutUs = this.$t("about_us_terminal_ads");
    this.cardTexts.socialMedia = {
      address: [
        {
          hint: this.$t("please_enter_your_address"),
          label: this.$t("address"),
          url: "www.qrland.ir",
          img: "/media/socialIcon/40icon/location.svg",
          svg: "svgLocation",
        },
        {
          hint: this.$t("please_enter_your_address"),
          label: this.$t("address"),
          url: "www.qr.terminalads.com",
          img: "/media/socialIcon/40icon/location.svg",
          svg: "svgLocation",
        },
      ],
      instagram: [
        {
          hint: this.$t("please_enter_instagram_address"),
          label: this.$t("instagram"),
          url: "https://instagram.com/terminalads",
          img: "/media/socialIcon/40icon/instagram.svg",
          svg: "svgInstagram",
        },
      ],
      whatsapp: [
        {
          hint: this.$t("please_enter_whatsapp_address"),
          label: this.$t("whatsapp"),
          url: "https://wa.me/982191017077",
          img: "/media/socialIcon/40icon/whatsapp.svg",
          svg: "svgWhatsapp",
        },
      ],
    };

    this.qrDesign = {
      qrStyleColors: {
        backcolor: "",
        frontColor: "",
        gradient_color: "",
        gradient: false,
        pattern: "default",
      },
      MarkerCenter: {
        topRight: "",
        bottomLeft: "",
        main: "",
        different_markers_color: false,
        eyePattern: "default",
      },
      QrMarkOut: {
        topRight: "",
        bottomLeft: "",
        markOutPattern: "default",
        main: "",
        different_markers_color: false,
      },
      QrFrame: {
        main: "",
        text: "SCAN ME",
        framePattern: "none",
        different_markers_color: false,
      },
      LogoImg: { noBg: false, logoSize: 100, logoImg: "none" },
    };

    Bus.$on("colorPalette", (value) => {
      this.cardTexts.pallete = value;
    });

    Bus.$on("socialMedias", (value) => {
      this.cardTexts.socialMedia = value;
    });

    Bus.$on("uploader", (value) => {
      this.cardTexts.photo = value;
    });

    Bus.$on("gradientType", (value) => {
      this.cardTexts.isGradient = value;
    });

    Bus.$on("eyeStyle", (value) => {
      this.eyeStyle = value;
    });

    Bus.$on("qrStyle", (value) => {
      this.qrStyle = value;
    });
  },

  computed: {
    ...mapGetters("qr", ["visitCardTransition", "hasWelcome"]),
  },

  watch: {
    "$i18n.locale": {
      handler() {
        this.updateTranslations();
        this.$forceUpdate();
      },
      immediate: true,
    },
    qrDesign: {
      handler() {
        this.loading = true;
        if (this.destinationUrl) {
          debounce(() => {
            this.preview(this.destinationUrl);
          }, 3000);
        }
      },
      deep: true,
    },
    visitCardTransition(val) {
      this.cardTexts.transition = val;
    },
    hasWelcome(val) {
      this.cardTexts.hasWelcome = val;
    },
    eyeStyle() {
      this.markQr(false);
    },
    qrStyle() {
      this.markQr(false);
    },
    qrSize() {
      this.markQr(false);
    },
  },
};
</script>

<style scoped>
.v-tab--active {
  background-color: var(--v-primary-base) !important;
  border-radius: 50px;
  color: white;
}
</style>
